import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const ProjectList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [projectList, setProjectList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  // Fetch list on mount
  useEffect(() => {
    callAPI("get", "admin/projects", "");
  }, []);

  // Handle API response
  useEffect(() => {
    if (response?.data && statusCode === 200) {
      setProjectList(response.data);
      setIsDelete(false); // Reset delete flag after fresh fetch
    }
  }, [response, statusCode]);

  // Handle delete success
  useEffect(() => {
    if (statusCode === 204 && isDelete) {
      toast.success("Project deleted successfully!");
      callAPI("get", "admin/projects", ""); // Refresh list
    }
  }, [statusCode, isDelete]);

  // Filter data
  const data = projectList.filter((item) => {
    const name = item.name?.toLowerCase() || "";
    const keyPoints = item.key_points?.toLowerCase() || "";
    return (
      name.includes(searchTerm.toLowerCase()) ||
      keyPoints.includes(searchTerm.toLowerCase())
    );
  });

  // Delete project
  const deleteRecord = (id) => {
    setIsDelete(true); // trigger deletion flow
    callAPI("delete", `admin/projects/${id}`, "");
  };

  return (
    <AdminAppBody
      loading={loading}
      content={
      
           <div className="container">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
            title="Project List"
            subTitle="Manage all registered Projects."
          />
            </div>
            <div className="col-md-6 text-end">
              <Link to="/projects/add">
                <button className="btn btn-primary">Add Project</button>
              </Link>
            </div>
          </div>
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <h5 className="mb-0 fw-semibold">Project List</h5>
                </div>
                <div className="col-12 col-md-5"></div>
                <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-start">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by name or Key Points"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Image & Name</th>
                    <th className="px-4 py-2">Key Points</th>
                    <th className="px-4 py-2">Technology</th>
                    <th className="px-4 py-2">Description</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={item.id} className="sys-list-table__row border-bottom">
                      <th className="px-4 py-2">{index + 1}</th>
                      <td className="px-4 py-2">
                        <div className="d-flex align-items-center">
                          <img
                            src={item.avatar}
                            alt={`${item.name}'s avatar`}
                            className="rounded-circle me-3"
                            style={{
                              width: "36px",
                              height: "36px",
                              objectFit: "cover",
                            }}
                          />
                          <span className="fw-medium">{item.name}</span>
                        </div>
                      </td>
                      <td className="px-4 py-2">{item.key_points}</td>
                      <td className="px-4 py-2">{item.technology}</td>
                      <td className="px-4 py-2">{item.description}</td>
                      <td className="px-4 py-2 text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link
                            to={uiRoutes.admin.projects.edit.replace(":id", item.id)}
                          >
                            <button
                              className="sys-list-table__action edit"
                              title="Edit Project"
                            >
                              <FaEdit />
                            </button>
                          </Link>
                          <button
                            className="sys-list-table__action delete"
                            title="Delete Project"
                            onClick={() => deleteRecord(item.id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ProjectList;
